import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old agent URLs now live under Settings, API keys and agents. */
export const Route = createFileRoute('/app/agents/$')({
  beforeLoad: ({ params }) => {
    const [kind, id] = (params._splat ?? '').split('/');
    if (kind === 'runs' && id) throw redirect({ to: '/app/settings/agents/runs/$runId', params: { runId: id }, replace: true });
    if (kind === 'sessions' && id)
      throw redirect({ to: '/app/settings/agents/sessions/$sessionId', params: { sessionId: id }, replace: true });
    if (kind === 'sessions') throw redirect({ to: '/app/settings/agents/sessions', replace: true });
    if (kind === 'jobs') throw redirect({ to: '/app/settings/agents/jobs', replace: true });
    throw redirect({ to: '/app/settings/agents', replace: true });
  },
});
